/* src/app/shared/components/auto-close-dialog/auto-close-dialog.component.scss */
.dialog-container {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  justify-content: flex-start;
  flex-grow: 1;
}
.dialog-container .close-icon {
  position: absolute;
  top: 0.75em;
  right: 0.5em;
  z-index: 99;
}
.dialog-content {
  height: 100%;
}
.progress-bar {
  width: 100%;
  height: 4px;
  background-color: #D9D9D9;
  margin-top: auto;
}
.progress-bar:not(.visible) {
  visibility: hidden;
}
.progress-fill {
  height: 100%;
  background-color: #0A8080;
  transition: width 10s linear;
}
:host(.auto-close-dialog) {
  display: flex;
  flex-direction: column;
  align-items: stretch;
  justify-content: flex-start;
  width: 100%;
  height: 100vh;
  position: relative;
}
@media screen and (min-width: 48rem) {
  :host(.auto-close-dialog) {
    height: 100%;
    min-height: 3.375rem;
    min-width: 21.5rem;
  }
}
/*# sourceMappingURL=auto-close-dialog.component.css.map */
